import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { TooltipPosition } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-tooltip-panel',
  imports: [SafePipe, NgTemplateOutlet],
  styleUrl: './tooltip-panel.component.scss',
  templateUrl: './tooltip-panel.component.html',
  host: {
    '[attr.role]': '"tooltip"',
  },
})
export class TooltipPanelComponent {
  readonly text = input('');
  readonly tpl = input<TemplateRef<unknown>>();
  readonly position = input<TooltipPosition>('above');
}
